















































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringKritisIgdDetail from "./MonitoringKritisIgdDetail.vue";
import { storeMonitoringKritisIgd } from "@/store/modules/MonitoringKritisIgdStore";
import MonitoringKritisIgdSvc from "@/services/MonitoringKritisIgdService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import moment from "moment";

@Component({
  components: {
    MonitoringKritisIgdDetail,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class MonitoringKritisIgdList extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  showForm = false;
  showDetail = false;
  editData: any = null;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("monitoring_kritis_igd", "create");
  }

  tableHeaders = [
    { text: "Tanggal", value: "tanggal", width: "100px" },
    { text: "EWSS", value: "ewss", width: "100px", sortable: false },
    { text: "GCS", value: "gcs", width: "70px", sortable: false },
    { text: "Disposisi", value: "disposisi", width: "120px" },
    { text: "Status", value: "status", width: "130px", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "150px" },
  ];

  mounted() {
    storeMonitoringKritisIgd.getByRegister(this.register);
  }

  get storeMonitoring() {
    return storeMonitoringKritisIgd;
  }

  get items() {
    return storeMonitoringKritisIgd.items;
  }

  get sudahAdaMonitoring(): boolean {
    return this.items.some(
      (it: any) => String(it.register_id) === String(this.register)
    );
  }

  ewssColor(kategori: string) {
    const colors: Record<string, string> = {
      normal: "green", ringan: "green", sedang: "amber darken-2", tinggi: "red", blue: "blue",
    };
    return colors[kategori] || "grey";
  }

  formatDate(date: string) {
    return date ? moment(date).format("DD-MM-YYYY") : "-";
  }

  tambah() {
    this.editData = null;
    this.showDetail = false;
    this.showForm = true;
  }

  edit(item: any) {
    this.editData = item;
    this.showDetail = false;
    this.showForm = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.showForm = false;
    this.showDetail = true;
  }

  cancelForm() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    // Detail bisa membuat/ubah record tanpa bubbling (agar tidak melompat balik
    // ke list saat menyimpan), jadi refresh saat kembali.
    storeMonitoringKritisIgd.getByRegister(this.register);
  }

  onSaved() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    storeMonitoringKritisIgd.getByRegister(this.register);
  }

  cetakPdf(item: any) {
    MonitoringKritisIgdSvc.printPdf(item.id);
  }

  async hapus(item: any) {
    const q = confirm("Anda yakin akan menghapus monitoring IGD ini?");
    if (q) {
      try {
        const resp = await MonitoringKritisIgdSvc.destroy(item.id);
        if (resp?.data?.status == "1") {
          appModule.NoticeDelay("Berhasil menghapus");
          storeMonitoringKritisIgd.getByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
